import React from 'react';

const MajDocumentation = () => {
    return (
        <div>
            
        </div>
    );
};

export default MajDocumentation